import { render, staticRenderFns } from "./AConfirmation.vue?vue&type=template&id=2cb40767&scoped=true&"
import script from "./AConfirmation.vue?vue&type=script&lang=ts&"
export * from "./AConfirmation.vue?vue&type=script&lang=ts&"
import style0 from "./AConfirmation.vue?vue&type=style&index=0&id=2cb40767&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb40767",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
